module.exports = __webpack_public_path__ + "static/media/IconSearch.9cfd97e1.svg";